/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shortcut_Keys_Name_Ad_Render_TtsInputs */



/**
* | output |
* | --- |
* | "Render Text-to-Speech" |
*
* @param {Shortcut_Keys_Name_Ad_Render_TtsInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const shortcut_keys_name_ad_render_tts = /** @type {((inputs?: Shortcut_Keys_Name_Ad_Render_TtsInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shortcut_Keys_Name_Ad_Render_TtsInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rendre le texte en synthese vocale")
	if (locale === "de") return /** @type {LocalizedString} */ ("Text-zu-Sprache-Wiedergabe")
	if (locale === "it") return /** @type {LocalizedString} */ ("Trasforma testo in voce")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Преобразование текста в речь")
	if (locale === "es") return /** @type {LocalizedString} */ ("Renderizar texto a voz")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("渲染文本转语音")
	if (locale === "ja") return /** @type {LocalizedString} */ ("テキスト読み上げのレンダリング")
	if (locale === "hi") return /** @type {LocalizedString} */ ("टेक्स्ट-टू-स्पीच रेंडर करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Renderizar texto para fala")
	return /** @type {LocalizedString} */ ("Render Text-to-Speech")
});